import { ArrowLeft} from 'assets/icons/index.js';
import TbodyListVivier from "./components/tbody.list.vivier";
import ScrollableTableWrapper, { useScrollContext } from '../../../../../../components/table/components/ScrollableTableWrapper';
import React from 'react';

const Thead = ({ setSortName, sortName, departments = [] }) => {
    const { hasHorizontalScroll = false } = useScrollContext();
    const handleSortName = () => {
        setSortName((prevState) => !prevState)
    };
    return (
        <>
            <tr className="sticky top-0 z-10 border-b border-gray-100">
                <th 
                    scope="col" 
                    className="sticky top-0 left-0 z-20 py-3.5 pl-4 pr-2 font-medium text-left rtl:text-right text-sm text-gray-700 w-80 bg-gray-50 border-b border-gray-100" 
                    onClick={handleSortName}
                    style={hasHorizontalScroll ? { boxShadow: '2px 0 0 0 rgba(243, 244, 246, 1)' } : {}}
                >
                    <div className='flex items-center gap-8'>
                        <div className='text-left rtl:text-right text-sm text-gray-700 '>
                            NOM
                        </div>
                        <div className={`${sortName ? "rotate-90" : "-rotate-90"} `}>
                            <ArrowLeft w={12} />
                        </div>
                    </div>
                </th>
                <th scope="col" className="sticky top-0 z-10 py-3.5 px-2 w-28 text-left text-sm font-medium text-gray-700 bg-gray-50 border-b border-gray-100 relative">
                    NB PROFILS
                </th>
                {departments.map((dept) => (
                    <th key={dept} scope="col" className="sticky top-0 z-10 py-3.5 px-2 w-28 text-left text-sm font-medium text-gray-700 bg-gray-50 border-b border-gray-100 relative">
                        {dept.toUpperCase()}
                    </th>
                ))}
                <th scope="col" className="sticky top-0 z-10 py-3.5 px-2 w-36 text-left text-sm font-medium text-gray-700 bg-gray-50 border-b border-gray-100 relative">
                    CRÉE LE
                </th>
                <th scope="col" className="sticky top-0 z-10 py-3.5 px-2 w-36 text-left text-sm font-medium text-gray-700 bg-gray-50 border-b border-gray-100 relative">
                    UTILISÉ LE
                </th>
                <th scope="col" className="sticky top-0 z-10 py-3.5 pl-2 pr-3 w-12 text-left text-sm font-medium text-gray-700 bg-gray-50 border-b border-gray-100 relative"></th>
            </tr>
        </>
    );
};


function TableListVivier({ viviers, isWaiting, setSortName, sortName, navigateToFicheVivier, departments = [] }) {
    return (
        <ScrollableTableWrapper className="overflow-y-auto">
            <table className={`table-fixed w-full divide-y divide-gray-200 bg-white animate-fadeIn`}>
                <thead className="sticky top-0 z-10">
                    <Thead setSortName={setSortName} sortName={sortName} departments={departments} />
                </thead>
                <tbody>
                    {(viviers?.length > 0) && viviers.map((vivier, index) => <TbodyListVivier key={index} champsBody={vivier} navigateToFicheVivier={navigateToFicheVivier} departments={departments} />)}
                </tbody>
            </table>
        </ScrollableTableWrapper>
    )
}

export default TableListVivier